<template>
    <div class="hzw-slider">
        <div class="hzw-list" >
            <div class="hzw-track" ref="slickTrack" :style="{width:`${slickTrackWidth}px`,transform:`translate3d(${transformX}px, 0px, 0px)`}">
                <slot></slot>
            </div>
            <slot name="dots"></slot>
            
        </div>
    </div>
</template>
<script>
export default {
    props:{
        options:{
            type:Object,
            default(){
                return {}
            }
        }
    },
    data(){
        return {
             defaultOptions:{
                initialSlide:0,
                centerPadding:60,
                width: 340
            },
            index:0,
            slickTrackWidth:1200,
            transformX:0
        }  
    },
    created(){
        this.index = this.defaultOptions.initialSlide;
        this.opt = Object.assign({},this.options,this.defaultOptions);
    },
    mounted(){
        this.$nextTick(()=>{
            this.goto(this.opt.initialSlide);
        })
    },
    updated(){
        this.$nextTick(()=>{
            const slickTrack = this.$refs.slickTrack
            let stw = 0;
            const cDiv = slickTrack.children;
            const {centerPadding,width} = this.opt;
            for (let i = 0; i < cDiv.length; i++) {
                const el  = cDiv[i];
                el.style.marginRight  = `${centerPadding}px`;
                const w =  width 
                stw += w + centerPadding;
                
            }
           this.slickTrackWidth = stw + width;
        })
    },
    methods:{
        goto(index){
            this.index = index;
            const slickTrack = this.$refs.slickTrack;
            const {centerPadding,width} = this.opt;
            const parentWidth = slickTrack.parentElement.getBoundingClientRect().width;
            const ws = parentWidth/2 - width;
            this.transformX = ws - (width+centerPadding) * index;
        },
        prev(){
            if(this.index > 0) {
                this.goto(this.index -1)
            }
        },
        next(){
            const slickTrack = this.$refs.slickTrack;
            if(this.index < slickTrack.children.length - 1) {
                this.goto(this.index + 1)
            }
        }
    }
}
</script>
<style lang="scss" scoped>
    .hzw-slider,.hzw-list,.hzw-track{
        width: 100%;
        height: calc( 100% - 4px);
        position: relative;
    }

    .hzw-track {
        height: 100%;
        width: 100%;
        display: flex;
        transition: all .6s ease-in-out;
    }

    
</style>


